"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNavigation = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _utils = require("../../common/utils");
var useNavigation = function useNavigation() {
  var navigate = (0, _reactRouterDom.useNavigate)();
  return (0, _react.useCallback)(function (path) {
    var prefix = (0, _utils.getRoutePrefix)();
    var route = path;
    if (prefix && !path.startsWith(prefix)) {
      route = "".concat(prefix).concat(path);
    }
    navigate(route);
  }, [navigate]);
};
exports.useNavigation = useNavigation;